import { Container, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useProcedureQuery } from "../../../queries";
import { FormCard, LoadingSpinner } from "../../../component-library";
import { Lists } from "../../lists";
import { displayDateAndTime, displayTimeZonelessDate } from "../../../helper-functions";
import { Tissue } from "../../../models";

export function ProcessingDashboard() {
    const navigate = useNavigate();
    const {
        processingDashboardQuery: { isFetching, data },
    } = useProcedureQuery({ queryType: "processingDashboard" });
    const upcomingProcessing = data?.upcomingProcessing ?? [];

    const getSurgeonName = (tissue: Tissue) => {
        const surgery = tissue.surgery ?? tissue.backupSurgery;
        if (!surgery?.surgeon) return "";
        return `${surgery.surgeon?.firstName} ${surgery.surgeon?.lastName ?? ""}`;
    };

    const getPunch = (tissue: Tissue) => {
        const surgery = tissue.surgery ?? tissue.backupSurgery;
        return surgery?.punch ?? "";
    };

    if (isFetching) return <LoadingSpinner />;

    return (
        <Container>
            <h1>Processing Dashboard</h1>
            <FormCard
                title={`Upcoming Processing ${upcomingProcessing.length ? `(${upcomingProcessing.length})` : ""}`}
            >
                {upcomingProcessing.length ? (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Tissue</th>
                                <th>Procedure</th>
                                <th>Surgeon</th>
                                <th>Scheduled On</th>
                                <th>To Be Shipped On</th>
                                <th>Punch</th>
                            </tr>
                        </thead>
                        <tbody>
                            {upcomingProcessing.map((tissue) => {
                                const procedure = tissue.tissueProcedures?.[0]?.procedure;
                                if (!procedure) return null;
                                return (
                                    <tr
                                        key={tissue.id}
                                        onClick={() =>
                                            navigate(
                                                `/lists/${Lists.TissuesUpcomingProcessing}/tissues/${tissue.id}/procedures/${procedure.id}`
                                            )
                                        }
                                        className="clickable"
                                        tabIndex={0}
                                    >
                                        <td>{tissue.number}</td>
                                        <td>{procedure.procedureType?.name}</td>
                                        <td>{getSurgeonName(tissue)}</td>
                                        <td>{displayTimeZonelessDate(procedure.scheduledOn)}</td>
                                        <td>{displayDateAndTime(procedure.toBeShippedOn)}</td>
                                        <td>{getPunch(tissue)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                ) : (
                    <p>No tissues found for selected regions.</p>
                )}
            </FormCard>
        </Container>
    );
}
